import * as React from 'react';
import { decode } from 'html-entities';
import { ServerStyleSheet } from 'styled-components';
import { renderToString } from 'react-dom/server';
import * as ReactDOM from 'react-dom';
import { Logger } from '../types/Logger';
import HeaderStandalone, { HeaderVariant } from './HeaderStandalone';
import { placeholderProps } from './placeholder-props';

const isClientSide = typeof window?.document !== 'undefined';

if (isClientSide) {
    // Exposes header for Club
    // React and ReactDOM also need to be exposed, as we need to maintain the versions
    window.OWWHeader = {
        React,
        ReactDOM,
        Header: HeaderStandalone,
    };

    if (window.headerReady) {
        window.headerReady(window.OWWHeader);
    }
} else {
    // Renders to generate static HTML
    const sheet = new ServerStyleSheet();
    /* eslint-disable react/jsx-props-no-spreading */
    const component = sheet.collectStyles(<HeaderStandalone {...placeholderProps} variant={window.variant} />);
    const componentHtml = decode(renderToString(component));
    const styleHtml = sheet.getStyleTags();

    window.result = styleHtml + componentHtml;
}

declare global {
    interface Window {
        result: string;
        variant: HeaderVariant;
        logger: Logger;
        OWWHeader: {
            React: typeof React;
            ReactDOM: typeof ReactDOM;
            Header: typeof HeaderStandalone;
        };
        headerReady: (data: Window['OWWHeader']) => void;
    }
}
